module.exports = __webpack_public_path__ + "static/media/empresariales-min.e54b837d.jpg";